import { IntegrationFormProvider } from 'modules/mobileApps/context/integrationForm';
import {
  ModalContextState,
  ModalProps,
  ModalType,
  useModalContext,
} from 'modules/mobileApps/context/modal';
import { TestPushFormProvider } from 'modules/mobileApps/context/testPushForm';
import { FC, PropsWithChildren } from 'react';
import { NoOpComponent } from 'utils/reactHelpers';
import { AssignIntegrationModal } from './AssignIntegrationModal';
import { ConfigureAndroidIntegrationModal } from './ConfigureAndroidIntegrationModal';
import { ConfigureIosIntegrationModal } from './ConfigureIosIntegrationModal';
import { ConfigureUnassignedIntegrationModal } from './ConfigureUnassignedIntegrationModal';
import { DeleteAppModal } from './DeleteAppModal';
import { DeleteIntegrationModal } from './DeleteIntegrationModal';
import { TestPushModal } from './TestPushModal';

const withContext =
  (Component: FC<ModalProps>, Provider: FC<PropsWithChildren>) => (props: ModalProps) => (
    <Provider>
      <Component {...props} />
    </Provider>
  );

const MODALS_MAPPER = {
  [ModalType.AssignIntegrationModal]: AssignIntegrationModal,
  [ModalType.ConfigureAndroidIntegrationModal]: withContext(
    ConfigureAndroidIntegrationModal,
    IntegrationFormProvider,
  ),
  [ModalType.ConfigureIosIntegrationModal]: withContext(
    ConfigureIosIntegrationModal,
    IntegrationFormProvider,
  ),
  [ModalType.ConfigureUnassignedIntegrationModal]: withContext(
    ConfigureUnassignedIntegrationModal,
    IntegrationFormProvider,
  ),
  [ModalType.DeleteAppModal]: DeleteAppModal,
  [ModalType.DeleteIntegrationModal]: DeleteIntegrationModal,
  [ModalType.TestPushModal]: withContext(TestPushModal, TestPushFormProvider),
};

const createModalsComponent =
  (
    mapper: Record<string, (modalProps: ModalProps) => JSX.Element>,
    useContext: () => ModalContextState,
  ) =>
  () => {
    const { openedModals } = useContext();

    return openedModals.map(({ modalType, modalProps = {} }) => {
      const Modal = mapper[modalType] || NoOpComponent;
      return <Modal key={modalType} {...modalProps} />;
    });
  };

export const Modals = createModalsComponent(MODALS_MAPPER, useModalContext);
